import getCombatantById from "./getCombatantById";
import getCombatantSlots from "./getCombatantSlots";
//-----------------------
// has previous counters
//-----------------------
export default async function hasPreviousCounters(parm) {
  console.log("---------------------------");
  console.log("hasPreviousCounters...");
  //---------------
  // get combatant
  //---------------
  let c = getCombatantById(parm.id);

  return new Promise((resolve, reject) => {
    //---------------------
    // get combatant slots
    //---------------------
    let call = getCombatantSlots(c.slug);
    call
      .then((slots) => {
        let previousCounters = slots.markers.some((a) => {
          return (a.marker_name == "counter" && 
          a.round == parm.round &&
          a.number < parm.num)
        });
        //-------------
        // return flag
        //-------------
        resolve(previousCounters);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
